// Salud del equipo LoRa (lo que manda en <base>/info): solo para admins.
// Formato de la trama en docs/TELEMETRIA_LORA.md.

export type ResetReason = 'unknown' | 'power_on' | 'software' | 'panic' | 'watchdog' | 'brownout' | 'deep_sleep';

export interface DeviceHealth {
  seq: number | null;
  batteryMv: number | null;
  batteryPct: number | null;
  charging: boolean | null;
  lowBattery: boolean | null;
  sensorError: boolean | null;
  clockUnset: boolean | null;
  solarMv: number | null;
  internalTempC: number | null;
  freeHeapKb: number | null;
  awakeMs: number | null;
  uptimeS: number | null;
  resetReason: ResetReason | null;
  firmware: string | null;
  intervalMin: number | null;
  rssi: number | null;
  snr: number | null;
}

export interface DeviceHealthRecord {
  recordedAt: string;
  health: DeviceHealth;
  rawHex: string | null;
  payload: Record<string, unknown> | null;
}

export interface DeviceHealthPoint {
  at: string;
  batteryMv: number | null;
  solarMv: number | null;
  internalTempC: number | null;
  rssi: number | null;
}

// El hub manda el motivo como número: el índice en este orden (el de la trama).
export const RESET_REASON_BY_CODE: ResetReason[] = ['unknown', 'power_on', 'software', 'panic', 'watchdog', 'brownout', 'deep_sleep'];

export const RESET_REASON_LABEL: Record<ResetReason, { text: string; bad: boolean }> = {
  unknown: { text: 'Desconocido', bad: false },
  power_on: { text: 'Se encendió', bad: false },
  software: { text: 'Reinicio pedido (p. ej. actualización)', bad: false },
  panic: { text: 'Error del firmware', bad: true },
  watchdog: { text: 'Se colgó (watchdog)', bad: true },
  brownout: { text: 'Le faltó tensión (batería)', bad: true },
  deep_sleep: { text: 'Despertó del sueño profundo', bad: false },
};

export function formatUptime(seconds: number): string {
  const d = Math.floor(seconds / 86400);
  const h = Math.floor((seconds % 86400) / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  if (d > 0) return `${d} d ${h} h`;
  if (h > 0) return `${h} h ${m} min`;
  return `${m} min`;
}

// Calidad del enlace de radio según el RSSI que midió el hub.
export function signalQuality(rssi: number): {
  text: string;
  color: 'success' | 'warning' | 'danger';
} {
  if (rssi >= -90) return { text: 'buena', color: 'success' };
  if (rssi >= -105) return { text: 'regular', color: 'warning' };
  return { text: 'mala', color: 'danger' };
}

// "01 02 01 05 ..." para leer la trama de a byte.
export const spacedHex = (hex: string) => hex.match(/.{1,2}/g)?.join(' ') ?? '';
